__turbopack_context__.v({
  "brandDescription": "footer-module-scss-module__rJcHtG__brandDescription",
  "brandHeading": "footer-module-scss-module__rJcHtG__brandHeading",
  "brandText": "footer-module-scss-module__rJcHtG__brandText",
  "columnSubtext": "footer-module-scss-module__rJcHtG__columnSubtext",
  "copyright": "footer-module-scss-module__rJcHtG__copyright",
  "followUsLabel": "footer-module-scss-module__rJcHtG__followUsLabel",
  "footerBottom": "footer-module-scss-module__rJcHtG__footerBottom",
  "footerBottomLinks": "footer-module-scss-module__rJcHtG__footerBottomLinks",
  "footerColumn": "footer-module-scss-module__rJcHtG__footerColumn",
  "footerContent": "footer-module-scss-module__rJcHtG__footerContent",
  "footerNav": "footer-module-scss-module__rJcHtG__footerNav",
  "inlineSocialIcons": "footer-module-scss-module__rJcHtG__inlineSocialIcons",
  "inlineSocialMedia": "footer-module-scss-module__rJcHtG__inlineSocialMedia",
  "newsletterInput": "footer-module-scss-module__rJcHtG__newsletterInput",
  "newsletterInputDivider": "footer-module-scss-module__rJcHtG__newsletterInputDivider",
  "newsletterSubmitBtn": "footer-module-scss-module__rJcHtG__newsletterSubmitBtn",
  "socialIconLink": "footer-module-scss-module__rJcHtG__socialIconLink",
  "socialMediaSection": "footer-module-scss-module__rJcHtG__socialMediaSection",
  "socialMediaSectionFollowUs": "footer-module-scss-module__rJcHtG__socialMediaSectionFollowUs",
});
